import { Buffer } from 'buffer';
import pako from 'pako';

export const decompress = (str: string) => {
  const decompressData = pako.inflate(Buffer.from(str, 'base64'));
  return JSON.parse(new TextDecoder('utf-8').decode(decompressData));
};
